export default class PermissionsController {
  constructor($uibModal, ContentService, Notification, ProfilePermissionsService, PermissionsService) {
    this.modal = $uibModal;
    this.service = ContentService;
    this.notify = Notification;
    this.profilePerms = ProfilePermissionsService;
    this.permsService = PermissionsService;
  }

  $onInit() {
    this.subscriptions = [];

    this.activeTab = 'users';
    this.currentProfile = this.profilePerms.getProfile();
    if (this.profilePerms.hasPermission('view-profiles')) {
      this.subscriptions.push(
        this.service.getAccountProfiles().subscribe(
          (profiles) => this.accountProfiles = profiles,
          (error) => this.accountProfiles = []
        )
      );
    } else {
      this.activeTab = 'invitations';
    }
    if (this.profilePerms.hasPermission('invite-user')) {
      this.subscriptions.push(
        this.service.getAccountInvitations().subscribe(
          (invitations) => this.accountInvitations = invitations,
          (error) => this.invitations = null
        )
      );
    }
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  switchTab(tab) {
    if (tab === 'invitations' && this.profilePerms.hasPermission('invite-user')) {
      this.activeTab = tab;
    } else if (tab === 'users' && this.profilePerms.hasPermission('view-profiles')) {
      this.activeTab = tab;
    }
  }

  openModalInviteUser() {
    var that = this;
    
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'invite-user-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $validation) => {
        "ngInject";
        $scope.emails = '';
        $scope.state = $state;
        $validation.setExpression({
          multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
        }).setDefaultMsg({
          multiemail: {
            error: "No es un correo o listado de correos válido"
          }
        })
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.inviteUser = () => {
          that.subscriptions.push(
            that.service.inviteUser($scope.emails).subscribe(
              (resp) => {
                that.notify.success('Usuario invitado exitosamente.!');
                $scope.state.reload()
                $scope.closeThisDialog();
              },
              (error) => {
                console.log(error);
              }
            )
          );
        };
      }
    });
  }

  openPermsModal(profile){
    var that = this;
    that.change = 0;
    this.subscriptions.push(
      this.permsService.getPermissions().subscribe(
        (permissions) => {
          this.modal.open({
            animation: true,
            size: 'lg',
            templateUrl: 'profile-perms-modal.html',
            appendClassName: 'ngdialog-theme-plain',
            controller: ($scope, ContentService, $state, $uibModalInstance, PermissionsService) => {
              "ngInject";
              $scope.profile = profile;
              $scope.currentProfile = that.currentProfile;
              $scope.perms = permissions.map((perm) => {
                if (perm.perm === 'is-admin'){
                  perm.enabled = profile.is_admin;
                  return perm;
                }
                perm.enabled = profile.permissions.indexOf(perm.perm) != -1
                return perm;
              });
              $scope.totalPerms = $scope.perms.length;
              $scope.permsLeft = $scope.perms.slice(0, $scope.totalPerms/2);
              $scope.permsRight = $scope.perms.slice($scope.totalPerms/2, $scope.totalPerms);
              $scope.closeThisDialog = () => $uibModalInstance.close();
              $scope.togglePermInProfile = (permission) => {
                if (permission.enabled) {
                  if (permission.perm === 'is-admin'){
                    profile.is_admin = true;
                  } else {
                    profile.permissions.push(permission.perm);
                  }
                } else {
                  if (permission.perm === 'is-admin'){
                    profile.is_admin = false;
                  } else {
                    profile.permissions.splice(profile.permissions.indexOf(permission.perm), 1);
                  }
                }
              };
              $scope.togglePerm = (permission, idx) => {
                if (!permission.enabled){
                  that.subscriptions.push(
                    that.service.assignPerm($scope.profile.id, {
                      perm: permission.perm
                    }).subscribe(
                      resp => {},
                      resp => $scope.perms[idx].enabled = false
                    )
                  );
                } else {
                  that.subscriptions.push(
                    that.service.revokePerm($scope.profile.id, {
                      perm: permission.perm
                    }).subscribe(
                      resp => {},
                      resp => $scope.perms[idx].enabled = true
                    )
                  );
                }
                that.change += 1;
              }
            }
          }).closed.then(() => {
            if (that.change > 0){
              this.notify.success('Sus cambios han sido realizados satisfactoriamente');
            }
          });
        }
      )
    );
  }

  deleteProfile(profile, idx){
    let currentProfile = this.profilePerms.getProfile().id;
    if (profile.id === currentProfile){
      this.notify.warning("Usted no puede borrar su propio perfil");
      return;
    }
    this.subscriptions.push(
      this.service.deleteProfile(profile.id).subscribe(
        resp => this.accountProfiles.splice(idx, 1),
        resp => {}
      )
    );
  }

  cancelInvitation(invitation, idx) {
    if (this.profilePerms.hasPermission('invite-user')) {
      this.subscriptions.push(
        this.service.cancelInvitation({email: invitation.email}).subscribe(
          resp => {
            this.accountInvitations.splice(idx, 1);
            this.notify.success("La invitación ha sido cancelada exitosamente");
          },
          resp => {}
        )
      );
    }
  }

}

PermissionsController.$inject = ['$uibModal', 'ContentService', 'Notification', 'ProfilePermissionsService', 'PermissionsService'];


// WEBPACK FOOTER //
// ./src/app/pages/permissions/permissions.controller.js